import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "./utilityFunction"

// Initial State
const initialState = {
    fetchSetting: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveSetting: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchSettingData = createApiThunk("setting", "fetch")
export const saveSettingData = createApiThunk("setting", "save")

// Slice
const settingSlice = createSlice({
    name: "setting",
    initialState,

    reducers: {
        resetSettingState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchSetting = {
                    ...state.fetchSetting, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveSetting = {
                    ...state.saveSetting, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingData.pending, (state) => updateState(state, "pending", "fetchSetting"))
            .addCase(fetchSettingData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchSetting", action.payload.data))
            .addCase(fetchSettingData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchSetting", action.payload))
            // Save data
            .addCase(saveSettingData.pending, (state) => updateState(state, "pending", "saveSetting"))
            .addCase(saveSettingData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveSetting", action.payload.data))
            .addCase(saveSettingData.rejected, (state, action) =>
                updateState(state, "rejected", "saveSetting", action.payload));
    },
});

export const { resetSettingState } = settingSlice.actions;
export default settingSlice.reducer;
